// What the view options' "Collapse all questions" and "Hide aytm Logic" rows change, kept apart from
// the panel so the keyboard shortcuts, which act while the panel is closed, change exactly the same.

const collapseKey = question => `c${(0 < question.position && question.position) || question.id}`

// Every question of the report that folds: its own questions, storytelling notes, virtual questions
// and Xpert questions.
export const collapsibleQuestions = (survey, report) =>
  survey.questions
    .filter(q => report.schema.includes(`q${q.position}`))
    .concat(Object.values(report.storytellings))
    .concat(Object.values(report.virtual))
    .concat(
      undefined != survey.scripts && Object.hasOwn(survey.scripts || {}, 'questions')
        ? Object.values(survey.scripts.questions)
        : []
    )

// A question marked to open collapsed is folded unless its flag says otherwise; any other only
// when its flag says so.
export const allCollapsed = (questions, params) =>
  questions.every(q => (true == q.collapse ? false != params[collapseKey(q)] : true == params[collapseKey(q)]))

// One params update that folds or unfolds every question, leaving a flag only where it differs
// from the question's own default.
export const collapseParams = (questions, collapsed) =>
  Object.fromEntries(
    questions.map(q => [
      collapseKey(q),
      collapsed ? (true == q.collapse ? null : true) : true == q.collapse ? false : null
    ])
  )

// Showing the logic again shows the @aliases too: they are hidden only while the logic is.
export const questionLogicParams = model =>
  'hide' == model.qLogicVisibility
    ? { question_logic: 'show', ...('hide' == model.qAliasesVisibility ? { question_aliases: 'show' } : {}) }
    : { question_logic: 'hide' }
